<template>
	<div class="pro_detail">
		<div class="proTop">
			<div class="widthBox">
				<el-row :gutter="40">
					<el-col :span="12" :xs="24">
						<div class="left">
							<img v-if="photoIndex == index" v-for="(item,index) in pageData.product_photo" :src="item.photo" class="pic">
							<div class="imgBpx acea-row row-center-wrapper">
								<div @click="picChange" data-type="1" class="imgBtn el-icon-arrow-left">
								</div>
								<div class="imgS hidden-xs-only acea-row row-center-wrapper">
									<img @click="picChange" :data-num="index" :class="photoIndex == index?'active':''" v-for="(item,index) in pageData.product_photo" :src="item.photo">
								</div>
								<div @click="picChange" data-type="2" class="imgBtn el-icon-arrow-right"></div>
							</div>
						</div>
					</el-col>
					<el-col :span="12" :xs="24">
						<div class="pro_title">
							<!-- <h4>男士私密养护系列</h4> -->
							<h2>{{pageData.product}}</h2>
							<div class="en">{{pageData.enproduct}}</div>
							<div class="info">
								<p v-for="item in pageData.remarks">{{item}}</p>
							</div>
						</div>
						<div class="item" v-for="item in pageData.product_explain">
							<div class="label">{{item.key}}</div>
							<div class="txt">
								{{item.value}}
							</div>
						</div>
						<div class="item" style="border: none;margin-top: 0;padding-top: 0;">
							<div class="price"><span>AUD:</span>{{pageData.price}}</div>
						</div>
						
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="page_detail">
			<div class="detail">
				<div class="widthBox" v-html="pageData.content"></div>
			</div>
		</div>
	</div>

</template>

<script>
	import titleOne from '@/components/titleOne.vue'
	export default {
		name: 'proDetail',
		components: {
			titleOne
		},
		data: function() {
			return {
				pageData:{},
				photoIndex:0,
				id:''
			};
		},
		created() {
			this.id = this.$route.query.id
			this.getData()
		},
		mounted() {
			this.$nextTick(function(){
				if(this.$route.query.to != undefined || this.$route.query.to != null){
					setTimeout(()=>{
						document.getElementById(this.$route.query.to).scrollIntoView()
					},500)
				}else{
					document.body.scrollIntoView()
				}
			})
		},
		methods:{
			getData(){
				this.$api.get('home/index/productDetail',{
					id:this.id
				}).then(res=>{
					this.pageData = res.data
				})
			},
			myUrl(e){
				this.pageData={}
				this.photoIndex=0
				this.id = e
				this.getData()
			},
			picChange(e){
				var type = e.currentTarget.dataset.type
				var photoIndex = this.photoIndex
				var num = e.currentTarget.dataset.num
				if(type == 1){
					if(photoIndex == 0){
						photoIndex = this.pageData.product_photo.length-1
					}else{
						photoIndex--
					}
				}else if(type == 2){
					if(photoIndex == (this.pageData.product_photo.length-1)){
						photoIndex=0
					}else{
						photoIndex++
					}
				}else{
					photoIndex = num
				}
				this.photoIndex = photoIndex
			}
		}
	}
</script>

<style lang="scss">
	$fontColor:#777;

	.pro_detail {
		padding-top: 80px;
		width: 100%;

		.proTop {
			.left {
				width: 100%;

				.pic {
					width: 100%;
				}

				.imgBpx {
					margin-top: 40px;

					.imgBtn {
						width: 80px;
						height: 120px;
						text-align: center;
						line-height: 120px;
						font-size: 28px;
						font-weight: bold;
						cursor: pointer;
					}

					.imgS {
						img {
							width: 120px;
							height: 120px;
							margin: 0 10px;
							cursor: pointer;
							opacity: 0.6;
							&.active{
								opacity: 1;
							}
						}
					}
				}
			}

			.pro_title {
				padding: 40px 0 30px 0;
				border-bottom: 1px solid $fontColor;

				h4 {
					font-size: 20px;
					color: $fontColor;
					line-height: 40px;
				}

				h2 {
					font-size: 40px;
					color: $fontColor;
					line-height: 56px;
				}

				.en {
					font-size: 18px;
					line-height: 36px;
					color: $fontColor;
				}

				.info {
					font-size: 20px;
					margin-top: 20px;
					line-height: 30px;
					p{
						font-size:20px;
					}
					color: rgba($color:$fontColor, $alpha: 0.7);
				}
			}

			.item {
				border-bottom: 1px solid $fontColor;
				padding: 20px 0;
				.price{
					width: 100%;
					height: 100px;
					line-height: 100px;
					text-align: center;
					font-size: 42px;
					color: #Fff;
					background: #b90f0f;
					margin-top: 100px;
					span{
						color: #Fff;
						font-size: 24px;
					}
				}
				.label {
					font-size: 24px;
					line-height: 36px;
					color: $fontColor;
					font-weight: bold;
				}

				.txt {
					font-size: 20px;
					line-height: 32px;
					margin-top: 6px;
					color: rgba($color:$fontColor, $alpha: 0.7);
				}
			}
		}

		.collocation {
			border-top: 1px solid $fontColor;
			margin-top: 80px;
			padding-top: 80px;
			
			.list{
				margin-top:50px;
			}
			.item {
				width: 100%;
				text-align: center;

				.pic {
					width: 100%;
				}
				.en{
					font-size:18px;
					color:rgba($color:$fontColor, $alpha: 0.5);
					margin-top:20px;
					line-height:28px;
				}
				.name{
					font-size:24px;
					line-height:28px;
					font-weight: bold;
					margin-top:5px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
				.more{
					width:150px;
					line-height:40px;
					color:#Fff;
					margin:40px auto 0;
					font-size:18px;
					text-align: center;
					background:$fontColor;
					border-radius:8px;
					cursor: pointer;
				}
			}
		}
		
		.page_detail{
			border-top: 1px solid $fontColor;
			margin-top: 80px;
			padding-top: 80px;	
			.widthBox{
				padding-top:40px;
			}
			video{
				width:100%;
				height:500px;
			}
		}
	}
	
	@media screen and(max-width:1400px) {
		.pro_detail{
			.proTop{
				.left{
					.imgBpx{
						margin-top:20px;
						.imgBtn{
							width:60px;
						}
						.imgS{
							img{
								width:120px;
								height:120px;
								margin:0 5px;
							}
						}
					}
				}
				.pro_title{
					padding:30px 0 25px;
					h4{
						font-size:18px;
					}
					h2{
						font-size:32px;
					}
					.en{
						font-size:16px;
					}
					.info{
						margin-top:10px;
						p{
							font-size:18px;
						}
					}
				}
				.item{
					padding:10px 0;
					.price{
						height: 70px;
						line-height: 70px;
						font-size: 32px;
						margin-top: 50px;
						span{
							font-size: 18px;
						}
					}
					.label{
						font-size:20px;
					}
					.txt{
						font-size:20px;
					}
				}
			}
			.collocation{
				margin-top:50px;
				padding-top:50px;
			}
			.page_detail{
				margin-top:50px;
				padding-top:50px;
				
			}
		}
	}
	@media screen and(max-width:1200px) {
		.pro_detail{
			.proTop{
				.left{
					.imgBpx{
						margin-top:10px;
						.imgBtn{
							width:44px;
						}
						.imgS{
							img{
								width:100px;
								height:100px;
							}
						}
					}
				}
				.pro_title{
					padding:15px 0 10px;
					h4{
						font-size:16px;
					}
					h2{
						font-size:28px;
					}
					.en{
						font-size:14px;
					}
					.info{
						margin-top:5px;
						p{
							font-size:16px;
						}
					}
				}
				.item{
					.label{
						font-size:16px;
					}
					.txt{
						font-size:16px;
					}
				}
			}
			.collocation{
				margin-top:40px;
				padding-top:40px;
			}
			.page_detail{
				margin-top:40px;
				padding-top:40px;
				
			}
		}
	}
	@media screen and(max-width:768px) {
		.widthBox{
					padding:0;
					width: 100%;
					p{
						width: 100%;
						img{
							width: 100% !important;
							height:auto !important;
						}
					}
				}
		.pro_detail{
			padding-top:20px;
			.proTop{
				// border: 1px solid #dedede;
				margin:0 20px;
				padding-bottom:20px;
				.pro_title{
					padding:15px 0 10px;
					h2{
						font-size:16px;
						line-height: 18px;
					}
					.en{
						font-size:12px;
					}
					.info{
						margin-top:5px;
						p{
							font-size:12px;
						}
					}
				}
				.item{
					.txt{
						font-size:12px;
					}
				}
				.m_pro_title{
					background:#F8FAFC;
					font-size:16px;
					color:#1D2A55;
					line-height:48px;
					padding:0 10px;
				}
				.left{
					position: relative;
					border-bottom:1px solid #eee;
					margin-bottom:20px;
					.imgBpx{
						.imgBtn{
							position: absolute;
							top:50%;
							width:40px;
							height:40px;
							line-height:40px;
							text-align: center;
							background:#FFF;
							border-radius:50%;
							font-size:18px;
							border: 1px solid #bfcfd8;
							transform: translate(0,-50%);
							&.el-icon-arrow-left{
								left:0px;
							}
							&.el-icon-arrow-right{
								right:0px;
							}
						}
					}
				}
				.item{
					padding:5px 0px;
					
					.label{
						// margin-right:10px;
					}
					.label,.txt{
						// display: inline;
						// line-height:20px;
						// font-weight: 500;
						// color:#333333;
					}
				}
			}
			
			.collocation{
				padding-top:20px;
				margin-top:0;
				border:0;
				.list{
					margin-top:20px;
					.item{
						.en{
							font-size:10px;
							line-height:16px;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							margin-top:8px;
						}
						.name{
							font-size:16px;
							line-height:20px;
						}
						.more{display: none;}
					}
				}
			}
			.page_detail{
				margin-top:0px;
				padding-top: 30px;
				border-top:0;
				.widthBox{
					padding-top: 0px;
				}
				video{
					height:240px;
				}
			}
		}
	}
</style>
